import React from 'react';
import { useTranslation } from 'react-i18next';
import { MobileMenuContainer, MobileNavLink } from './styles';

interface MobileMenuProps {
  isOpen: boolean;
  user: { displayName?: string; email?: string } | null;
  isLoggingOut: boolean;
  onNavClick: (event: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => void;
  onLogout: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
  isOpen,
  user,
  isLoggingOut,
  onNavClick,
  onLogout,
}) => {
  const { t } = useTranslation();

  return (
    <MobileMenuContainer $isOpen={isOpen}>
      <MobileNavLink href="#features" onClick={(event) => onNavClick(event, 'features')}>{t('nav.features')}</MobileNavLink>
      <MobileNavLink href="#integrations" onClick={(event) => onNavClick(event, 'integrations')}>{t('nav.integrations')}</MobileNavLink>
      <MobileNavLink href="#technology" onClick={(event) => onNavClick(event, 'technology')}>{t('nav.technology')}</MobileNavLink>
      <MobileNavLink href="#metrics" onClick={(event) => onNavClick(event, 'metrics')}>{t('nav.comparison')}</MobileNavLink>
      <MobileNavLink href="#security" onClick={(event) => onNavClick(event, 'security')}>{t('nav.security')}</MobileNavLink>
      <MobileNavLink href="#pricing" onClick={(event) => onNavClick(event, 'pricing')}>{t('nav.pricing')}</MobileNavLink>
      <MobileNavLink href="#enterprise" onClick={(event) => onNavClick(event, 'enterprise')}>{t('nav.enterprise')}</MobileNavLink>
      <MobileNavLink href="#faq" onClick={(event) => onNavClick(event, 'faq')}>{t('nav.faq')}</MobileNavLink>
      {user && (
        <MobileNavLink href="#" onClick={onLogout} style={{ opacity: isLoggingOut ? 0.7 : 1 }}>
          {isLoggingOut ? t('nav.loggingOut') : t('nav.logout')}
        </MobileNavLink>
      )}
    </MobileMenuContainer>
  );
};
